import queryString from "query-string";
import history from "../routers/History";

export function popBackStack() {
  const { redirectTo } = queryString.parseUrl(window.location.href).query;
  history.push(redirectTo == null ? "/documentos" : redirectTo);
}